<div class="modal-backdrop show flex flex-wrap -mx-2 items-center">
    <div class="flex-none w-full my-12 px-2">
        <article class="flex justify-center">
            <mat-spinner></mat-spinner>
        </article>
    </div>
</div>
